<!-- eslint-disable vuejs-accessibility/no-static-element-interactions -->
<template>
  <div class="uberall-search-line-item">
    <div class="uberall-search-line-item__content">
      <div class="uberall-search-line-item__header">
        <h3
          class="uberall-search-line-item__title text-body-2xs-regular"
          v-text="getStoreName(storeData.name)"
        />

        <div class="uberall-search-line-item__open-hours">
          <div
            class="uberall-search-line-item__is-open"
            :class="{ 'is-open': storeData.openNow }"
          />
          <p
            class="uberall-search-line-item__hours-label text-body-2xs-regular"
            v-text="storeCurrentOpenHours"
          />
        </div>
      </div>
      <p
        class="uberall-search-line-item__street text-body-2xs-regular"
        v-text="storeData.streetAndNumber"
      />
      <p
        class="uberall-search-line-item__address text-body-2xs-regular"
        v-text="`${storeData.city}, ${storeData.province} ${storeData.zip}`"
      />
      <a
        class="uberall-search-line-item__pn text-body-2xs-underline"
        :href="`tel: ${storeData.phone}`"
        v-text="storeData.phone"
      />

      <div class="uberall-search-line-item__hours-wrapper">
        <button
          class="uberall-search-line-item__hours-button"
          type="button"
          @click.stop="toggleDetails"
        >
          <span
            class="uberall-search-line-item__hours-title text-body-2xs-regular"
            v-text="`Services & hours`"
          />

          <component :is="hoursIcon" />
        </button>

        <div class="uberall-search-line-item__hours-content">
          <div class="uberall-search-line-item__hours-column">
            <p
              v-for="(openData, index) of getHours"
              :key="index"
              class="uberall-search-line-item__hours-column-item text-body-2xs-regular"
            >
              <span v-text="openData.days" /> <span v-text="openData.hour" />
            </p>
          </div>

          <ul
            v-if="storeData.services"
            class="uberall-search-line-item__services-list"
          >
            <li
              v-for="(service, index) of storeData.services"
              :key="index"
            >
              <span
                class="text-body-2xs-regular"
                v-text="service"
              />
            </li>
          </ul>
        </div>
      </div>

      <div class="uberall-search-line-item__buttons-wrapper">
        <btn
          class="uberall-search-line-item__get-directions"
          :label="$string('store_locator.get_directions')"
          modifiers="primary center"
          @click.stop="showOnMap"
        />
        <btn
          class="uberall-search-line-item__view-store-details"
          :label="$string('store_locator.view_store_details')"
          modifiers="secondary center"
          :url="storePageUrl"
          type="button"
        />
      </div>
    </div>
  </div>
</template>

<script>

import Btn from '~global/btn/btn'
import IconPlus from '~icons/directional-navigation/plus.svg'
import IconMinus from '~icons/directional-navigation/minus.svg'
import { getOpenHours, getStoreHours, openStoreOnMap, refineStoreName } from '../helpers'

export default {
  name: 'UberallSearchLineItem',

  components: {
    Btn,
    IconPlus,
    IconMinus,
  },

  props: {
    storeData: {
      type: Object,
      default: () => ({}),
    },
  },

  emits: ['location-id'],

  data() {
    return {
      showHours: false,
    }
  },

  computed: {

    /**
     * Return icon for summary button
     * @returns {String}
     */
    hoursIcon() {
      if (this.showHours) {
        return 'icon-minus'
      }

      return 'icon-plus'
    },

    /**
     * Store work hours
     */
    getHours() {
      return getOpenHours(this.storeData)
    },

    /**
     * Store is open hours
     */
    storeCurrentOpenHours() {
      return getStoreHours(this.storeData)
    },

    /**
     * Get store URL on Shopify
     */
    storePageUrl() {
      const pageField = this.storeData?.customFields?.find((customField) => customField.name === 'shopify_store_page_url')

      return pageField?.value
    },
  },

  methods: {

    /**
     * Show/hide list item details
     * @param event
     */
    toggleDetails(event) {
      const targetElement = event.target
      const buttonWrapper = targetElement.nodeName === 'BUTTON' ? targetElement : targetElement.parentNode
      const detailsWrapper = buttonWrapper.parentNode.querySelector('.uberall-search-line-item__hours-content')

      detailsWrapper.classList.toggle('showing')
      this.showHours = !this.showHours
    },

    /**
     * Emit store id when clicked
     */
    emitChosenStore() {
      this.$emit('location-id', this.storeData.id)
    },

    /**
     * Return store name without prefix
     * @param storeName
     */
    getStoreName(storeName) {
      return refineStoreName(storeName)
    },

    /**
     * Open store direction in external app/browser
     */
    showOnMap() {
      openStoreOnMap({ lat: this.storeData.lat, lng: this.storeData.lng }, this.storeData.name)
    },

  },
}
</script>
